<template>
  <div
    class="wt-prompt-template-name-input wt2-modal-inner"
    :class="{ '-edit': isEditMode }"
  >
    <div class="-title-box">
      <span
        class="wt2-text-xl -blue"
        v-text="isEditMode ? 'Edit Template' : 'Save New Template'"
      />
    </div>
    <div class="-content">
      <div class="-input-wrapper">
        <input
          ref="input"
          v-model="inputValue"
          type="text"
          :placeholder="placeholder"
          :maxlength="maxLength"
          class="-template-input"
          @keyup.enter="confirm"
          @keyup.esc="closeModal"
        />
      </div>
      <div class="-prompt-text" v-if="isEditMode">
        <textarea
          ref="promptTextInput"
          v-model="promptTextEditable"
          class="-prompt-text-input"
          :placeholder="promptTextPlaceholder"
        />
      </div>
      <div class="-message wt2-text-s">
        Template will be available to everyone on your team.
      </div>
    </div>
    <div class="-actions">
      <wt-button
        class="-smaller-font -min-width-unset"
        type="transparent"
        text="Cancel"
        @click="closeModal"
      />
      <wt-button text="Save" :disabled="!allowSave" @click="confirm" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'wtPromptTemplateNameInput',

  props: {
    closeModal: {
      type: Function,
      required: true,
    },
    defaultValue: {
      type: String,
      default: '',
    },
    promptText: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Name your template...',
    },
    promptTextPlaceholder: {
      type: String,
      default: 'Enter your prompt text...',
    },
    maxLength: {
      type: Number,
      default: 75,
    },
    onConfirm: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      inputValue: this.defaultValue,
      promptTextEditable: '',
      mode: 'new', // new or edit
    };
  },

  computed: {
    isEditMode() {
      return this.mode === 'edit';
    },
    allowSave() {
      return (
        this.inputValue.trim() &&
        (this.isEditMode ? this.promptTextEditable?.trim() : true)
      );
    },
  },

  mounted() {
    // Focus and select the input on mount
    if (this.promptText) {
      this.promptTextEditable = this.promptText || '';
      this.mode = 'edit';
    }
    this.$nextTick(() => {
      if (this.$refs.input && !this.isEditMode) {
        this.$refs.input.focus();
        this.$refs.input.select();
      } else if (this.isEditMode && this.$refs.promptTextInput) {
        this.$refs.promptTextInput.focus();
        this.$refs.promptTextInput.setSelectionRange(0, 0);
      }
    });
  },

  watch: {
    defaultValue(newVal) {
      this.inputValue = newVal;
    },
  },

  methods: {
    confirm() {
      if (this.inputValue && this.inputValue.trim()) {
        this.onConfirm(this.inputValue.trim(), this.promptTextEditable);
        this.closeModal();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'style_guide/_sg_variables.scss';

.wt-prompt-template-name-input {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding-top: 40px;
  padding-right: 30px;
  padding-left: 30px;
  width: 500px;
  height: 275px;
  &.-edit {
    height: 405px;
  }

  .-content {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding-bottom: 50px;
    padding-top: 20px;
  }
  .-title-box {
    color: $color-primary;
  }

  .-message {
    color: rgba(0, 0, 0, 0.6);
  }

  .-input-wrapper {
    margin-bottom: 20px;
    width: 100%;
  }

  .-template-input {
    border: 0;
    border-bottom: 1px solid rgba(89, 89, 89, 0.6);
    border-radius: 0;
    box-shadow: 0;
    color: #595959;
    width: 100%;
    font-size: 14px;
    padding: 5px 10px;

    &:hover,
    &:focus {
      background-color: rgba(0, 0, 0, 0.05);
    }

    &::placeholder {
      color: rgba(0, 0, 0, 0.4);
    }
  }

  .-prompt-text {
    margin-bottom: 20px;
    width: 100%;
  }

  .-prompt-text-input {
    width: 100%;
    height: 145px;
    resize: none;
    padding: 10px;
    font-size: 14px;
    border: none;
    border-radius: 0;
    transition: height 0.2s ease-in;
    background-color: rgba(0, 0, 0, 0.05);
  }

  .-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
}
</style>
